const onlineLearning = {
  path: 'onlineLearning/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/onlineLearning'], resolve)
}
export default onlineLearning



// WEBPACK FOOTER //
// ./src/router/pages/student_user/onlineLearning/index.js